import { PaintBucket } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const PaintBucketIcon = createLucideIcon(PaintBucket);
